import React from 'react';
import { instanceOf, bool } from 'prop-types';
import { connect } from 'react-redux';
import SelectionItem from './SelectionItem';

const SelectionList = ({ selectedTargets, loading }) => {
  return (
    <div className="ie--target--selections--list">
      {selectedTargets.map((item, i) => (
        <SelectionItem item={item} key={i} loading={loading} />
      ))}
    </div>
  );
};

SelectionList.propTypes = {
  selectedTargets: instanceOf(Array),
  loading: bool,
};

SelectionList.defaultProp = {
  selectedTargets: [],
  loading: false,
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { selectedTargets } = turnkeyOmnibus;
  return {
    selectedTargets,
  };
};

export default connect(
  mapStateToProps,
  null
)(SelectionList);
